import WrapperService from "@/modules/core/services/wrapper-service";
import {createPageableParams} from "@/modules/core/services/table-utils";

const serviceName = 'Task-Documentation-Service: ';
const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/task/task-documentation';
const sortTableFields = ["name"];
const sortDatabaseFields = ["name"];
export default class TaskDocumentationService {

  static async saveOrUpdate(documentationDto, file, succsessF, errorF) {
    let isEdit = !!documentationDto.id;

    let formData = new FormData();
    if (file && file.name) {
      formData.append("document", file, file.name);
    }

    documentationDto.src = '';
    formData.append("documentationDto", JSON.stringify(documentationDto));

    if (isEdit) {
      await WrapperService.put(API_URL + '/update/' + documentationDto.id, formData, serviceName, succsessF, errorF);
    } else {
      await WrapperService.post(API_URL + '/create', formData, serviceName, succsessF, errorF);
    }
  }

  static async readAllPaginatedByTaskIdFromAPI(taskId, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortTableFields, sortDatabaseFields);
    await WrapperService.get(API_URL + '/page/' + taskId, {params: params}, serviceName, successF, errorF);
  }

  static async readAllPaginatedByFacilityIdFromAPI(facilityId, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortTableFields, sortDatabaseFields);
    await WrapperService.get(API_URL + '/page/facility/' + facilityId, {params: params}, serviceName, successF, errorF);
  }

  static async delete(documentId, successF, errorF){
    await WrapperService.delete(API_URL + '/' + documentId, null, serviceName, successF, errorF);
  }

  static async readAllOrderPaginatedByTaskIdFromAPI(taskId, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortTableFields, sortDatabaseFields);
    await WrapperService.get(API_URL + '/order/page/' + taskId, {params: params}, serviceName, successF, errorF);
  }
}